import { ChangeDetectionStrategy, Component,  input } from '@angular/core';
import { Transforms } from '@shared/helpers/transforms';

@Component({
    selector: 'form-dialog-title',
    templateUrl: './form-dialog-title.component.html',
    styleUrl: './form-dialog-title.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class FormDialogTitleComponent {
  
  public label = input.required<string>();

  public hasMandatoryFields = input(false, {
    transform: Transforms.toBoolean,
    alias: 'has-mandatory-fields'
  });
}